import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Box from '@mui/material/Box';

const ProfileImage = ({ profile, image, className, alt }) => (
  <Box
    sx={{
      img: {
        border: 1,
        borderColor: 'grey.700',
        borderRadius: '50%',
        aspectRatio: '1/1',
        objectFit: 'cover',
      },
    }}
  >
    <GatsbyImage
      image={getImage(
        image ||
          profile.image.childImageSharp?.gatsbyImageData ||
          profile.image.gatsbyImageData,
      )}
      className={className}
      alt={
        alt || profile.name ? `Profil-Bild von ${profile.name}` : 'Profil-Bild'
      }
    />
  </Box>
);

export default ProfileImage;
